(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FavouriteFilterDialogController', FavouriteFilterDialogController);

    FavouriteFilterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'FavouriteFilter', 'Employee'];

    function FavouriteFilterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, FavouriteFilter, Employee) {
        var vm = this;
        vm.favouriteFilter = entity;
        vm.employees = Employee.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:favouriteFilterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.favouriteFilter.id !== null) {
                FavouriteFilter.update(vm.favouriteFilter, onSaveSuccess, onSaveError);
            } else {
                FavouriteFilter.save(vm.favouriteFilter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
